// src/features/game/progress.js
export const defaultProgress = {
  wave: 1,
  gold: 0,
  level: 1,
  xp: 0,
  inv: [], // [{id, name, type}]
};

export function loadProgress(){
  try { return JSON.parse(localStorage.getItem('progress')) || {...defaultProgress}; }
  catch { return {...defaultProgress}; }
}
export function saveProgress(p){ localStorage.setItem('progress', JSON.stringify(p)); }

export function grantRewards(progress, { gold=0, xp=0 }){
  const p = { ...progress };
  p.gold += gold; p.xp += xp;
  const need = needXpForLevel(p.level);
  while (p.xp >= need) { p.xp -= need; p.level += 1; }
  saveProgress(p); return p;
}
export function needXpForLevel(lv){ return 50 + (lv-1)*25; }

export function enemyScaleForWave(wave){
  return 1 + Math.min(1.5, wave * 0.12);
}

// ✅ ค่าศัตรูสเกลตาม Wave/Tier
export function enemyStatsForWave(wave) {
  const tier = Math.floor((wave - 1) / 5);          // ขยับ Tier ทุก 5 เวฟ
  const hpMult = 1 + wave * 0.18 + tier * 0.35;     // ศัตรูอึดขึ้นเรื่อย ๆ
  const strBase = 6 + Math.floor(wave * 0.6) + tier * 2; // ศัตรูตีแรงขึ้นเรื่อย ๆ
  const skillBonus = Math.min(0.35 + wave * 0.01, 0.70); // โอกาสใช้สกิล สูงสุด 70%
  return { hpMult, strBase, skillBonus, tier };
}

/* ---------- SHOP CATALOG (แยกหมวด) ---------- */
export const SHOP_ITEMS = {
  potions: [
    { id:'potion_s', name:'Small Potion', type:'potion', cost:30, effect:{ heal:25 } },
    { id:'potion_l', name:'Large Potion', type:'potion', cost:55, effect:{ heal:60 } },
  ],
  stats: [
    { id:'ring_atk',  name:'Ring of Force', type:'gear',  cost:70,  effect:{ atk:+3 } },
    { id:'charm_int', name:'Charm of Mind', type:'gear',  cost:70,  effect:{ int:+3 } },
    { id:'boots_agi', name:'Swift Boots',   type:'gear',  cost:70,  effect:{ agi:+3 } },
  ],
  weapons: [
    // weapon แบบ Beginner เท่านั้น (base ต่ำ พอไปตีบวกต่อ)
    { id:'club',   name:'Club',        type:'weapon', cost:80,  effect:{ weapon:{ name:'Club',        base:3 } } },
    { id:'dagger', name:'Dagger',      type:'weapon', cost:95,  effect:{ weapon:{ name:'Dagger',      base:4 } } },
    { id:'spear',  name:'Spear',       type:'weapon', cost:110, effect:{ weapon:{ name:'Spear',       base:5 } } },
  ],
};

/* ---------- ค่าบวกอาวุธต่อครั้ง (เพิ่ม base +1) ---------- */
export function enhanceCost(currentBase){
  // ยิ่ง base สูง ค่ายิ่งแพง
  return 40 + currentBase * 15; // ex. base 4 → 100, base 10 → 190
}
